module.exports = __webpack_public_path__ + "static/img/brushing-after-meal.51ace25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brushing-after-meal.svg
// module id = dde2
// module chunks = 0